import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    width: '100%',
  },
  dialogContent: {
    margin: '40px 10px',
  },
  inputRoot: {
    width: '100%',
  },
  input: {
    border: '1px solid #9B9B9B',
    borderRadius: 10,
    marginBottom: 10,
    padding: '6px 10px',
  },
  error: {
    color: '#fa755a',
  },
  label: {
    color: theme.palette.text.primary,
  },
  stripeInput: {
    padding: 10,
    border: '1px solid #9B9B9B',
    height: 40,
    marginBottom: 10,
    borderRadius: 10,
  },
  stripeRef: {
    width: '100%',
  },
  dialogActionContianer: {
    width: '100%',
    padding: '10px 95px',
  },
  dialogActionButton: {
    minWidth: 200,
  },
}));

export default useStyles;
